module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-ExtraBold.e4445ae.woff";